module.exports = __webpack_public_path__ + "a0976fe6579217fe3189ce493a847053.png";